(function (window, document) {
  var copiedLabel = function (button) {
    return button.getAttribute('data-copied-label') || 'Copied';
  };
  var idleLabel = function (button) {
    return button.getAttribute('data-idle-label') || 'Copy address';
  };
  var failedLabel = function (button) {
    return button.getAttribute('data-failed-label') || 'Could not copy';
  };

  var fallbackCopy = function (value) {
    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;left:-9999px;top:0;';
    document.body.appendChild(input);
    input.focus();
    input.select();
    input.setSelectionRange(0, value.length);
    var ok = document.execCommand('copy');
    input.remove();
    if (!ok) throw new Error('copy failed');
  };

  var writeClipboard = function (value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value).catch(function () {
        fallbackCopy(value);
      });
    }
    fallbackCopy(value);
    return Promise.resolve();
  };

  var labelNode = function (button) {
    return button.querySelector('[data-copy-label]') || button;
  };

  var copyServerAddress = function (button) {
    if (!button) return false;
    var address = button.getAttribute('data-copy-address');
    if (!address) return false;
    if (button.getAttribute('data-copy-busy') === 'true') return true;

    button.setAttribute('data-copy-busy', 'true');
    button.setAttribute('data-copied', 'true');
    button.setAttribute('aria-live', 'polite');
    labelNode(button).textContent = copiedLabel(button);

    Promise.resolve()
      .then(function () {
        return writeClipboard(address);
      })
      .catch(function () {
        button.removeAttribute('data-copied');
        labelNode(button).textContent = failedLabel(button);
      })
      .then(function () {
        window.setTimeout(function () {
          button.removeAttribute('data-copied');
          button.removeAttribute('data-copy-busy');
          labelNode(button).textContent = idleLabel(button);
        }, 1800);
      });

    return false;
  };

  var bindCopyButtons = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-copy-address]');
    for (var i = 0; i < buttons.length; i += 1) {
      (function (button) {
        if (button.getAttribute('data-copy-bound') === 'true') return;
        button.setAttribute('data-copy-bound', 'true');
        button.addEventListener('click', function (event) {
          event.preventDefault();
          copyServerAddress(button);
        });
      })(buttons[i]);
    }
  };

  window.copyServerAddress = copyServerAddress;
  window.bindCopyButtons = bindCopyButtons;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCopyButtons(document);
    });
  } else {
    bindCopyButtons(document);
  }
})(window, document);
